var React = require('react');

function IconGoto (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.172 11H2V13H30.172L24.808 18.364L26.222 19.778L34 12L26.222 4.22205L24.808 5.63605L30.172 11Z","fill":"white"}));
}

IconGoto.defaultProps = {"width":"36","height":"24","viewBox":"0 0 36 24","fill":"none"};

module.exports = IconGoto;

IconGoto.default = IconGoto;
